// by default keep track of format in order to allow easier migration
// eslint-disable-next-line import/prefer-default-export
export const APP_INSTANCE_RESOURCE_FORMAT = 'v1';
